<template>
  <div>
    <div v-for="(typeGroup, typeIndex) in groupedByType(activityAudits)" :key="typeIndex">
      <table class="finding">
        <tr style="background-color: lightgray; color: black; text-align: center;">
          <th>
            {{ typeGroup.activityAuditTypeName }}
          </th>
        </tr>
      </table>

      <table class="stripe" style="border-top-left-radius: 0px; border-top-right-radius: 0px;">
        <thead>
          <tr style="text-align: left;">
            <th style="width: 25%;">Activity</th>
            <th style="width: 15%;">Handled Correctly</th>
            <th style="width: 40%;">Notes</th>
            <th style="width: 20%;">Reason</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in typeGroup.rows" :key="index">
            <td style="color: black;">{{ row.activityName }}</td>
            <td style="color: black;">
              <span v-if="row.handledCorrectly === true">Yes</span>
              <span v-else-if="row.handledCorrectly === false">No{{ row.exclude ? ' (Excluded)' : '' }}</span>
              <span v-else>-</span>
            </td>
            <td style="color: black;">{{ row.notes || '' }}</td>
            <td style="color: black;">{{ row.reasonForChange || '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="!activityAudits || activityAudits.length === 0">
      <div style="font-style: italic; font-size: 14px;">No activity audits on Worksheet</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'InpatientWorksheetActivityAudits',
    props: {
      activityAudits: {
        type: Array,
        default: function() {
          return []
        }
      }
    },
    methods: {
      groupedByType(arr) {
        if (!arr) return []
        const typeNames = [...new Set(arr.map(x => x.activityAuditTypeName))].sort()
        return typeNames.map(name => ({
          activityAuditTypeName: name,
          rows: arr.filter(x => x.activityAuditTypeName === name)
        }))
      }
    }
  }
</script>
